import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserPageSF from './SuperUserPageSF'

const SuperUserLoanPageUI = ({ context, className, loan,
  topnav, backLink, headerText, subHeaderText,
  dimension, centered, children, page, more, onMore
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    loan={loan}
    sideBar={
      <SideBarUI
        page={page}
        loan={loan}
        more={more}
        onMore={onMore}
      />
    }
  />

const SideBarUI = ({ page, loan, more, onMore }) =>
  <div className='t_sidebar'>
    {
      loan &&
      <>
        <div className='g_m_bottom_50'><b>{loan.loanRefNum}</b></div>
        {/* <hr /> */}
        <SideBarItemUI label='Summary' to={`/su/loans/${loan.loanId}`} active={page === 'details'} />
        {
          loan.status == 'disbursed' && !more && onMore &&
          <div className='g_link g_m_top_50 g_m_left_50' onClick={onMore}>
            More
          </div>
        }
        {
          (loan.status !== 'disbursed' || more || !onMore) &&
          <>
            <div className='g_m_top_50 g_m_bottom_50'><b>Assessments</b></div>
            <SideBarItemUI label='Recommendation' to={`/su/loans/${loan.loanId}/recommendation`} active={page === 'recommendation'} />
            <SideBarItemUI label='Feasibility' to={`/su/loans/${loan.loanId}/feasibility`} active={page === 'feasibility'} />
            <SideBarItemUI label='Sizing' to={`/su/loans/${loan.loanId}/sizing`} active={page === 'sizing'} />
            <SideBarItemUI label='Interest Rate' to={`/su/loans/${loan.loanId}/interestRate`} active={page === 'interestRate'} />
            <SideBarItemUI label='Security Cover' to={`/su/loans/${loan.loanId}/securityCover`} active={page === 'securityCover'} />
            {/* <hr /> */}
            <div className='g_m_top_50 g_m_bottom_50'><b>Underwriting</b></div>
            <SideBarItemUI label='Onboarding Data' to={`/su/loans/${loan.loanId}/onboardingData`} active={page === 'onboardingData'} />
            <SideBarItemUI label='Broad Terms' to={`/su/loans/${loan.loanId}/broadTerms`} active={page === 'broadTerms'} />
            {/* <SideBarItemUI label='Project' to={`/su/loans/${loan.loanId}/project`} active={page === 'project'} /> */}
            <SideBarItemUI label='Term Sheet' to={`/su/loans/${loan.loanId}/termSheet`} active={page === 'termSheet'} />
            <SideBarItemUI label='Information' to={`/su/loans/${loan.loanId}/tokenS`} active={page === 'tokenS'} />
            {
              loan.termSheet.amountF2 &&
              <SideBarItemUI label='Amortization' to={`/su/loans/${loan.loanId}/amortization`} active={page === 'amortization'} />
            }
            <SideBarItemUI label='Use of Proceeds' to={`/su/loans/${loan.loanId}/proceeds/draft`} active={page === 'proceeds'} />
            <SideBarItemUI label='Cash Flow' to={`/su/loans/${loan.loanId}/cashFlow`} active={page === 'cashFlow'} />
            <SideBarItemUI label='Loan documents' to={`/su/loans/${loan.loanId}/resolutions`} active={page === 'loanDoc'} />
            <SideBarItemUI label='Document Sign' to={`/su/loans/${loan.loanId}/esigning`} active={page === 'esigning'} />
            {/* <SideBarItemUI label='Projects/Vehicles' to={`/su/loans/${loan.loanId}/projects`} active={page === 'projects'} /> */}
            {/* <SideBarItemUI label='Cash Flow Projections' to={`/su/loans/${loan.loanId}/compliance/ts`} active={page === 'ts'} /> */}
            <SideBarItemUI label='Disbursement Checklist' to={`/su/loans/${loan.loanId}/disbursement`} active={page === 'disbursement'} />
            {/* <SideBarItemUI label='Disbursement Checklist' to={`/su/loans/${loan.loanId}/disbursementChecklist`} active={page === 'disbursement_checklist'} /> */}
            {/* <hr /> */}
          </>
        }
        <div className='g_m_top_50 g_m_bottom_50'><b>Compliance</b></div>
        <SideBarItemUI label='Condition Precedent' to={`/su/loans/${loan.loanId}/compliance/cp`} active={page === 'cp'} />
        <SideBarItemUI label='Condition Subsequent' to={`/su/loans/${loan.loanId}/compliance/cs`} active={page === 'cs'} />
        <SideBarItemUI label='Monitoring Remarks' to={`/su/loans/${loan.loanId}/monitoring`} active={page === 'monitoring'} />
        <SideBarItemUI label='Legal Remarks' to={`/su/loans/${loan.loanId}/legalRemarks`} active={page === 'legalRemarks'} />
        <SideBarItemUI label='Loan Cheque' to={`/su/loans/${loan.loanId}/loanCheque`} active={page === 'loanCheque'} />
        <SideBarItemUI label='Compliance' to={`/su/loans/${loan.loanId}/compliance`} active={page === 'compliance'} />
<SideBarItemUI label='DSRA Status' to={`/su/loans/${loan.loanId}/dsra`} active={page === 'dsra'} />
        {/* <hr /> */}
        {
          loan.disbursement.dateF1 &&
          <>
            <div className='g_m_top_50 g_m_bottom_50'><b>Repayments</b></div>
            <SideBarItemUI label='Loan Balances' to={`/su/loans/${loan.loanId}/bankAccounts`} active={page === 'balances'} />
            <SideBarItemUI label='Repayments' to={`/su/loans/${loan.loanId}/repayments/v2`} active={page === 'repayments'} />
            <SideBarItemUI label='Prepayment' to={`/su/loans/${loan.loanId}/prepayment`} active={page === 'prepayment'} />
            <SideBarItemUI label='Report Card' to={`/su/loans/${loan.loanId}/reportCard`} active={page === 'reportCard'} />
          </>
        }
        <SideBarItemUI label='Loan Fees' to={`/su/loans/${loan.loanId}/fees`} active={page === 'fees'} />
        <SideBarItemUI label='Loan Transactions' to={`/su/loans/${loan.loanId}/transactions`} active={page === 'loanTxns'} />
      </>
    }
  </div>

const SideBarItemUI = ({ label, to, active }) =>
  <Link to={to} className={`${active ? 'active' : ''} t_sidebar_item`}>
    {label}
  </Link>

export default SuperUserLoanPageUI

